var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-progress-circular',{attrs:{"rotate":-90,"size":60,"width":8,"value":_vm.percent,"color":"#ffc545"}},[_c('span',{staticClass:"subtitle-2"},[_c('animated-int',{attrs:{"value":_vm.average,"decimals":2}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }